
/*
 * webmd kibana function integration 
 */
if (typeof window !== 'undefined') {
  window.webmd = window.webmd || {};
  window.webMDBeaconCalls = window.webMDBeaconCalls || [];
  window.webmd.createBeaconCall = function(logType, evt, sid) {
    // do not run beacon call for non Production enviroments like localhost
    //if (window.webmd && webmd.ads && window.webmd.ads.pageTargets && indow.webmd.ads.pageTargets.env == "0") {
      window.webMDBeaconCalls.push({
        type: `media-log-${logType}`,
        event: evt,
        wcbEvent: sid,
        url: document.URL,
      });
    //}
    }
}
